export const fileUploadProps = {
  accept: ['application/pdf', 'image/png'], // Only PDF and PNG files are accepted for now
  maxFiles: window.env.OPENAI_IMAGES_HARD_LIMIT, // Maximum number of files allowed
  maxFileSize: 20 * 1024 * 1024, // 20MB
};
